export const TOGGLE_PLAYER = 'TOGGLE_PLAYER'
export const RECEIVE_NOW_PLAYING = 'RECEIVE_NOW_PLAYING'
export const SET_NOW_PLAYING = 'SET_NOW_PLAYING'
export const REQUEST_TITLE = 'REQUEST_TITLE'
export const ZED_PLAYER_PLAY = 'ZED_PLAYER_PLAY'
export const CHANGE_PLAYER_STATE = 'CHANGE_PLAYER_STATE'

export function togglePlayer(visible = null) {
  return {
    type: TOGGLE_PLAYER,
    visible
  }
}

function receiveNowPlaying() {
  return {
    type: RECEIVE_NOW_PLAYING
  }
}

export function setNowPlaying(title, image, url = null) {
  return {
    type: SET_NOW_PLAYING,
    title,
    image,
    url
  }
}

export function zedPlayerPlay(src, position) {
  return {
    type: ZED_PLAYER_PLAY,
    src,
    position
  }
}

function requestTitle() {
  return {
    type: REQUEST_TITLE
  }
}

function changePlayerState() {
  return {
    type: CHANGE_PLAYER_STATE
  }
}
